<template>
<div class='reason-cont'>
  <div class='row no-gutters reason'>
      <div class="reason-name">
          {{$t(reason.name)}}
      </div>
      <div class='pipe-container'>
        <div class='basic-pipe pipe'>
            <img v-if="reason.isBasic" src='/static/img/shop/checked.png' />
        </div>
        <div class='pro-pipe pipe'>
            <img v-if="reason.isPro" src='/static/img/shop/checked.png' />
        </div>
      </div>
  </div>
    <div class='row no-gutters line'></div>
  </div>
</template>

<script>
export default {
    name: 'SpreadSheetItem',
    props: {
        reason: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang='scss' scoped>
.reason-cont{
    width: 100%;
}
.pipe-container{
    display: flex;
    .pro-pipe{
        width: 96px;
        background-color: #1b4c6e;
    }
    .basic-pipe{
        width: 96px;
    }
   .pipe{
       display: flex;
       align-items: center;
       justify-content: center;
   }
}
 .reason-name{
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    max-width: calc(100% - 192px);
    letter-spacing: normal;
    text-align: left;
    color: var(--white);
    display: flex;
    align-items: center;
    margin-top: 15.4px;
    margin-bottom: 16.4px;
 }

.line{
    height: 1px;
    width: 100%;
    opacity: 0.3;
    background-color: var(--white);
}
.reason{
    display: flex;
    justify-content: space-between;
}

</style>
